<template>
  <div class="clm-top-line">
    <button type="button" class="clm-top-back" @click="$emit('action')">
      <div class="clm-top-back__img">
        <img src="/local/img/form/arrow.svg" alt="">
      </div>
      <div class="clm-top-back__text">
        Назад
      </div>
    </button>
    <!--<clm-ctrl-lang :locale="locale" />-->
    <clm-ctrl-help :need-help="needHelp" />
  </div>
</template>

<script>
import clmCtrlLang from "../clm-ctrl-lang.vue";
import clmCtrlHelp from "../clm-ctrl-help.vue";
export default {
  name: "a-mob-header",
  components: {
    clmCtrlLang,
    clmCtrlHelp
  },
  inject: ['locale', 'needHelp'],
  emits: ['action'],
}
</script>
